const FormViewerConstant = {
    event: {
        FORM_STRUCTURE_CHANGED: 'FormViewerConstant.formStructureChanged',
        FORM_LAZY_RENDERING_START: 'FormViewerConstant.formLazyRenderingStart',
        FORM_LAZY_RENDERING_END: 'FormViewerConstant.formLazyRenderingEnd',
        FORM_RENDERING_OPTIMIZE_WATCHERS: 'FormViewerConstant.FormRenderingOptimizeWatchers',
        SUPPLEMENTAL_FORM_ADDED: 'FormViewerConstant.SupplementalFormAdded',
        SUPPLEMENTAL_FORM_REMOVED: 'FormViewerConstant.SupplementalFormRemoved',
        OPTIMIZE_FORM_WATCHERS: 'formViewerConstant.OptimizeFormWatchers',
        CREATE_FIELD_MESSAGE: 'FormViewerConstant.CreateFieldMessage',
        UPDATE_FIELD_MESSAGE: 'FormViewerConstant.UpdateFieldMessage',
        DELETE_FIELD_MESSAGE: 'FormViewerConstant.DeleteFieldMessage',
        RENAME_FIELD_MESSAGE: 'FormViewerConstant.RenameFieldMessage',
        SHOW_REMOTE_FIELD_NOTIFICATION: 'FormViewerConstant.remoteFieldUpdate',
        SHOW_NEXT_REQUIRED_FIELD: 'FormViewerConstant.showNextRequiredField',
        SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD: 'FormViewerConstant.showNextRequiredFieldAfterFormLoad',
        SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID: 'FormViewerConstant.showNextRequiredFieldFormSummaryGrid',
        CREATE_NEW_SUPPLEMENTAL_FORM: 'FormViewerConstant.CreateNewSupplementalForm',
        DELETE_SUPPLEMENTAL_FORM: 'FormViewerConstant.DeleteSupplementalForm',
        UPDATE_ROOT_FORM: 'FormViewerConstant.UpdateRootForm',
        CREATE_ROW: 'FormViewerConstant.CreateRow',
        DELETE_ROW: 'FormViewerConstant.DeleteRow',
        UPDATE_ROW: 'FormViewerConstant.UpdateRow',
        ROW_RENDERING_COMPLETE: 'FormViewerConstant.RowRenderingComplete',
        FORM_DATA_READY: 'FormViewerConstant.RenderData',
        CLOSE_CALENDAR_POPUP: 'FormViewerConstant.CloseCalendarPopup',
        DROPDOWN_UPDATE_ACTIVE_INDEX: 'formViewerConstant.DropdownUpdateActiveIndex',
        RELOAD_FORM: 'formViewerConstant.ReloadForm',
        FOCUSED_FIELD_CHANGED: 'formViewerConstant.FocusedFieldChanged',
        INITIAL_RENDERING_COMPLETE: 'formViewerConstant.InitialRenderingComplete',
        FORM_TEMPLATE_INVALIDATED: 'formViewerConstant.FormTemplateInvalidated',
        REPEATING_ROW_SELECTED: 'formViewerConstant.RepeatingRowSelected',
        REPEATING_ROW_PAGE_CHANGE: 'formViewerConstant.RepeatingRowPageChange',
        formBuilder: {
            FIELD_COMPONENT_SELECTED: 'formViewerConstant.formBuilder.FieldComponentSelected',
            FORM_TEMPLATE_UPDATED: 'formViewerConstant.formBuilder.FormTemplateUpdated',
            FORM_TEMPLATE_SAVED: 'formViewerConstant.formBuilder.FormTemplateSaved',
            COLUMN_RESIZED: 'formViewerConstant.formBuilder.ColumnResized',
            COLUMN_RESIZING: 'formViewerConstant.formBuilder.ColumnResizing',
            DISABLE_DRAGGABLE_ELEMENTS: 'formViewerConstant.formBuilder.DisableDraggableElements',
            ENABLE_DRAGGABLE_ELEMENTS: 'formViewerConstant.formBuilder.EnableDraggableElements',
            REARRANGE_COLUMN: 'formViewerConstant.formBuilder.RearrangeColumn'
        },
        ruleBuilder: {
            REVIEW_RULE:'formViewerConstant.ruleBuilder.reviewRule'
        }
    },
    configuration: {
        event: {
            CREATE_NEW_ROW: 'FormViewerConstant.configuration.CreateNewRow',
            CREATE_NEW_COMPONENT: 'FormViewerConstant.configuration.CreateNewComponent',
            CREATE_NEW_SECTION: 'FormViewerConstant.configuration.CreateNewSection',
            CREATE_NEW_ROW_REPEATER: 'FormViewerConstant.configuration.CreateNewRowRepeater',
            FIELD_SELECTION_CHANGE: 'FormViewerConstant.configuration.FieldSelectionChange',
            ROW_SELECTION_CHANGE: 'FormViewerConstant.configuration.RowSelectionChange',
            SECTION_SELECTION_CHANGE: 'FormViewerConstant.configuration.SectionSelectionChange',
            FIELD_DRAG_START: 'FormViewerConstant.configuration.FieldDragStart',
            DRAG_FORM_ELEMENT: 'FormViewerConstant.configuration.DragFormElement',
            DRAG_FORM_ELEMENT_END: 'FormViewerConstant.configuration.DragFormElementEnd',
            DELETE_FIELD: 'FormViewerConstant.configuration.DeleteField',
            DELETE_ROW: 'FormViewerConstant.configuration.DeleteRow',
            DELETE_SECTION: 'FormViewerConstant.configuration.DeleteSection',
            UPDATE_ROW_REPEATER_SETTING: 'FormViewerConstant.configuration.UpdateRowRepeaterSetting',
            UPDATE_COMPONENT_SETTING: 'FormViewerConstant.configuration.UpdateComponentSetting',
            SAVE_FORM_TEMPLATE_CHANGES: 'FormViewerConstant.configuration.SaveFormTemplateChanges',
            FIELD_MOVED_IN_ROW: 'FormViewerConstant.configuration.FieldMovedInRow'
        },
        dragOperationType: {
            MOVE: 'FormViewerConstant.DragOperationType.Move',
            INSERT: 'FormViewerConstant.DragOperationType.Insert'
        },
        formStructureType: {
            SECTION: 'FormViewerConstant.FormStructureType.Section',
            ROW: 'FormViewerConstant.FormStructureType.Row',
            ROW_REPEATER: 'FormViewerConstant.FormStructureType.RowRepeater',
            COMPONENT: 'FormViewerConstant.FormStructureType.Component'
        },
        INSERT_BEFORE: 'FormViewerConstant.InsertBefore',
        INSERT_AFTER: 'FormViewerConstant.InsertAfter',
        INSERT_ABOVE: 'FormViewerConstant.InsertAbove',
        INSERT_BELOW: 'FormViewerConstant.InsertBelow'
    },
    timing: {
        FORM_VIEWER: 'FormViewerConstant.FormViewer',
        LOAD_DATA: 'FormViewerConstant.LoadData',
        BEGIN_RENDERING: 'FormViewerConstant.BeginRendering',
        INITIAL_SCREEN_RENDERED: 'FormViewerConstant.InitialScreenRendered',
        FORM_FULLY_RENDERED: 'FormViewerConstant.FormFullyRendered'
    }
};

angular.module('umFormViewer')
    .constant('formViewerConstant', FormViewerConstant);
